export default defineAppConfig({
  ui: {
    colors: {
      neutral: 'stone'
    },
    input: {
      defaultVariants: {
        size: 'xl'
      }
    },
    button: {
      defaultVariants: {
        size: 'xl'
      }
    },
    textarea: {
      defaultVariants: {
        size: 'xl'
      }
    }
  }
})
